import axios from 'axios';
import { FILES_ENDPOINT } from 'cfgCommon/endpoints'

export const getFileAssociation = async (endpoint, id) => {
    try {
        const res = await axios.get(FILES_ENDPOINT + '/' + endpoint + '/' + id);
        return res;
    } catch (error) {
        console.log(`Error getFileAssociation `, error)
        return error;
    }
}